import React, { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from '@/Util/globals';
import BlankPageLayout from '@/Layouts/BlankPageLayout';
import { Button } from 'reactstrap';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

interface Props {
  children?: ReactNode;
  router: AppRouterInstance;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger('error')('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <BlankPageLayout>
          <div className="mt-6">
            <h1 className="text-center mt-6">There was a temporary issue.</h1>
            <h1 className="text-center">Please refresh the page and try again.</h1>
            <div className="text-center mt-6">
              <Button
                color="primary"
                className="mt-3"
                size={'xxl'}
                onClick={(): void => this.props.router.refresh()}
              >
                Reload
              </Button>
            </div>
          </div>
        </BlankPageLayout>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
